<template>
  <div class="container-fluid">
    <b-table
      class="table-borderless table-responsive-md mb-3"
      striped
      :items="articles"
      :fields="overview_material_fields"
      thead-class="small text-nowrap border-bottom"
    >
      <template #cell(price)="row">
        {{ row.item.getPrice() }}
      </template>
      <template #cell(total_price)="row">
        {{ row.item.getTotalPrice() }}
      </template>
      <template #cell(details)="row">
        {{ row.item.article.getDetail("shrttext") }}
      </template>
    </b-table>
    <div class="row">
      <div class="col-12">
        <hr />
      </div>
      <div class="col-10">
        <p class="h5">
          Materiallistenwert zur Anlagenauswertung in € (zzgl. gesetzlicher
          MwSt.)
        </p>
      </div>
      <div class="col-2 text-right">
        <p class="h5">{{ parseFloat(totalPrice).toFixed(2) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Unit from "@models/building/Unit";
import Room from "@models/building/Room";
import { setLabels } from "@services/helpers/langHandler";

import StoredArticle from "@models/articles/StoredArticle";
import StoredRoomArticle from "@models/articles/StoredRoomArticle";
import SelectedUserArticle from "@models/articles/SelectedUserArticle";

export default {
  props: ["index", "unitId"],
  data() {
    return {
      totalPrice: 0,
      articles: [],
    };
  },

  methods: {
    setLabels: setLabels,

    setData() {
      this.articles = [];
      this.totalPrice = 0;
      // Get all articles of the unit sort by accessorygroup
      let unitArticles = StoredArticle.query()
        .where("unit_id", this.unitId)
        .orderBy("accessorygroup_id")
        .with(["article"])
        .where("quantity", (quantity) => quantity >= 1)
        .where("status", "default")
        .get();

      // Get all articles of the rooms sort by accessorygroup
      const rooms = Room.query().where("unitId", this.unitId).get();
      // Get array of all room ids
      const roomIds = rooms.map((room) => room.id);
      // Get all articles of the rooms sort by accessorygroup
      let roomArticles = StoredRoomArticle.query()
        .where("room_id", (id) => roomIds.includes(id))
        .orderBy("accessorygroup_id")
        .with(["article"])
        .where("quantity", (quantity) => quantity >= 1)
        .where("status", "default")
        .get();

      // merge both collections
      let articles = unitArticles.concat(roomArticles);

      // check for duplicates sum up quantity and delete duplicate
      articles.forEach((article) => {
        // skip if article has no article object
        if (!article.article) {
          return;
        }

        let index = this.articles.findIndex(
          (item) => item.article_id === article.article_id
        );
        if (index === -1) {
          this.articles.push(article);
        } else {
          this.articles[index].quantity += article.quantity;
        }
      });

      // get User articles
      let userArticles = SelectedUserArticle.query()
        .where("quantity", (quantity) => quantity >= 1)
        .with(["userArticle"])
        .get();

      // push user articles to articles
      userArticles.forEach((article) => {
        this.articles.push(article);
      });

      // set total price
      this.articles.forEach((article) => {
        this.totalPrice += article.getTotalPrice();
      });
    },
  },
  computed: {
    /* 		articles() {
  return getArticleIndex();
}, */
    unit() {
      return Unit.query().where("id", this.id).with("rooms").first();
    },
    overview_material_fields: {
      get() {
        return this.setLabels(
          this.$store.state.inputs.overview_material_fields
        );
      },
    },
  },
  mounted() {
    this.setData();
  },
};
</script>
